import { PublicCommonTheme } from './Common';

export const PublicTheme = {
    Common: PublicCommonTheme,
}